import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _mergeProps(_ctx.$attrs, {
    style: $options.getComputedStyle,
    innerHTML: $props.value
  }), null, 16, _hoisted_1);
}